import { network } from "../network.js";

function generateMessageEl(type, data) {
    const chatMessage = document.createElement('div');

 
    chatMessage.className = (type === "local") ? "chat-local-message" : "chat-received-message";

    // 2. Format values with fallbacks
    const coordsText = (data.xPos !== undefined && data.yPos !== undefined) 
        ? `(${data.xPos}, ${data.yPos})` 
        : "(0, 0)";

    const username = data.username || (type === "local" ? "You" : `Player_${data.userId?.substring(0, 4)}`);
    
    // Format timestamp (e.g., "11:11 PM") or fallback to current time
    const timeText = data.timestamp 
        ? new Date(data.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    // 3. Construct inner markup structure
    chatMessage.innerHTML = `
        <div class="chat-user-info">
            <div class="chat-user-icon"></div> 
            <div class="chat-user-coordinates">${coordsText}</div>
        </div>
        <div class="chat-message-body">
            <div class="chat-message-header">
                <span class="chat-message-username">${username}</span>
                <span class="chat-message-time">${timeText}</span>
            </div>
            <div class="chat-message-content"></div>
        </div>
    `;

    // 4. Safely set textContent for message text to prevent HTML injection / XSS
    chatMessage.querySelector('.chat-message-content').textContent = data.message || '';

    return chatMessage;
}


export class chatSubmenu {

    constructor(containerEl) {
        this.container = containerEl;
        // this.uiManager = uiManager;

        this.ui = {
            info: {
                container: this.container.querySelector('#chat-info'),
                world: this.container.querySelector('#chat-current-world'),
                playersOnline: this.container.querySelector('#chat-current-players-online')
            },

            displayContainer: this.container.querySelector('#chat-display-container'),

            input: {
                container: this.container.querySelector('#chat-input-container'),
                iconSelector: this.container.querySelector('#chat-icon-selector'),
                textArea: this.container.querySelector('#chat-message-input'),
                sendBtn: this.container.querySelector('#chat-send-button')
            }

        };
    }

    init() {
        this.updateInfo();
        
        //Send message on click
        this.ui.input.sendBtn.addEventListener("click", () => this.sendMessage());

        //Send message on enter
        this.ui.input.textArea.addEventListener("keydown", (e) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault(); // Prevents a new line from being added to the textarea
                this.sendMessage();
            }
        });

        //setup ui update on message
        network.onChatMessage = (data) => {
            this.renderMessage(data);
        }
    }

    renderMessage(data) {

        let messageType = (data.userId === network.socket?.id) ? "local" : "received";
        let messageDiv = generateMessageEl(messageType, data)

        this.ui.displayContainer.appendChild(messageDiv);
        this.ui.displayContainer.scrollTop = this.ui.displayContainer.scrollHeight;
    }

    sendMessage() {
        const messageText = this.ui.input.textArea.value.trim();

        if (messageText.length === 0) return;

        network.sendChatMessage(messageText);

        this.ui.input.textArea.value = "";
    }

    updateInfo() {
        const worldName = `load from network`;
        this.ui.info.world.innerText = `${worldName}`;

        const currentPlayersOnline = `load from network`;
        this.ui.info.playersOnline.innerText = `ONLINE: ${currentPlayersOnline}`;
    }


}